// mbscan manager-client の同名部品と共通。片側だけで変えない
import { createLink } from '@tanstack/react-router'

import { DataTableAnchor } from '@/components/ui/data-table/row-link'

// 汎用UIをルート定義へ依存させず、利用画面では型安全な to / params / search を保つ。
export const DataTableLink = createLink(DataTableAnchor)
